import { styled } from 'styled-components'

import { Banner, ButtonAsA, Button } from '@b-stock/fe-core/bstock-react'
import { Typography } from '@b-stock/fe-core/design-system'

// NotificationOverlay.tsx passes a wider `maxWidth` to `showSnackbar` (this
// surface carries a title, body and CTA, not just a short confirmation line);
// this just fills whatever width that gives it.
export const StyledBanner = styled(Banner)`
  width: 100%;
`

export const Message = styled.p`
  ${Typography.Body3}
  margin: 0;
`

export const ActionRow = styled.div`
  margin-top: 0.75rem;
`

export const ActionLinkButton = styled(ButtonAsA)`
  width: auto;
`

export const ActionButton = styled(Button)`
  width: auto;
`
